import * as React from "react";
import { QueryClientProvider } from "@tanstack/react-query";

import { REACT_QUERY_CLIENT } from "components/app_layout/AppProviders";
import { PaywallProvider } from "lib/providers/Paywall";
import { ProHelperProvider } from "lib/providers/ProHelper";

type Props = {
  children: React.ReactNode;
};

export function ReportSubscriptionContextProvider({ children }: Props): JSX.Element {
  return (
    <QueryClientProvider client={REACT_QUERY_CLIENT}>
      <PaywallProvider>
        <ProHelperProvider>{children}</ProHelperProvider>
      </PaywallProvider>
    </QueryClientProvider>
  );
}
